module.exports = __webpack_public_path__ + "img/photo-09.88c369ed.jpg";